import { render, staticRenderFns } from "./registerEmail.vue?vue&type=template&id=312804cf&scoped=true&"
import script from "./registerEmail.vue?vue&type=script&lang=js&"
export * from "./registerEmail.vue?vue&type=script&lang=js&"
import style0 from "./registerEmail.vue?vue&type=style&index=0&id=312804cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312804cf",
  null
  
)

export default component.exports